module.exports = __webpack_public_path__ + "media/assets/icon-search-a2d0ea0cf5403809135af4df6fa4edc1.svg";